<!--整车数据-->
<template>
  <div class="whole-statistics-container">
    <div class="page-header">
      <h2>整车数据查询</h2>
    </div>
    
    <!-- 搜索和筛选区域 -->
    <div class="search-container">
      <el-form :inline="true" size="small" :model="searchForm" class="search-form">
        <el-form-item label="车牌号">
          <el-input v-model="searchForm.vehiclePlate" placeholder="请输入车牌号" clearable style="width: 180px;"></el-input>
        </el-form-item>
        
        <el-form-item label="车辆状态">
          <el-select v-model="searchForm.vehicleStatus" placeholder="请选择车辆状态" clearable style="width: 120px;">
            <el-option label="运行中" value="running"></el-option>
            <el-option label="停止" value="stopped"></el-option>
            <el-option label="充电中" value="charging"></el-option>
            <el-option label="故障" value="fault"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="ACC状态">
          <el-select v-model="searchForm.accStatus" placeholder="请选择ACC状态" clearable style="width: 100px;">
            <el-option label="开" value="on"></el-option>
            <el-option label="关" value="off"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="数据时间">
          <el-date-picker
            v-model="searchForm.dataTimeRange"
            type="datetime"  
            placeholder="请选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            style="width: 200px;"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
          <el-button @click="refreshData">刷新数据</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 数据表格 -->
    <div class="table-container">
      <el-table :data="tableData" stripe style="width: 100%;" v-loading="loading">
        <el-table-column prop="vehiclePlate" label="车牌号" min-width="120"></el-table-column>
        <el-table-column prop="vehicleStatus" label="车辆状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.vehicleStatus)">
              {{ formatVehicleStatus(scope.row.vehicleStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="accStatus" label="ACC" min-width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.accStatus" active-value="on" inactive-value="off" disabled></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="gear" label="档位" min-width="80"></el-table-column>
        <el-table-column prop="chargingStatus" label="充电状态" min-width="100">
          <template slot-scope="scope">
            <span>{{ formatChargingStatus(scope.row.chargingStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chargingMode" label="充电模式" min-width="100"></el-table-column>
        <el-table-column prop="faultLevel" label="系统故障等级" min-width="120">
          <template slot-scope="scope">
            <el-tag :type="getFaultLevelType(scope.row.faultLevel)">
              {{ formatFaultLevel(scope.row.faultLevel) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="soc" label="SOC(%)" min-width="100">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.soc" :stroke-width="10" :text-inside="true"></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="insideTemp" label="车内温度" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.insideTemp }}℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="outsideTemp" label="车外温度" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.outsideTemp }}℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="brakeTravel" label="刹车行程值" min-width="120"></el-table-column>
        <el-table-column prop="acceleratorTravel" label="加速踏板行程值" min-width="140"></el-table-column>
        <el-table-column prop="totalCharge" label="总充电量(kwh)" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.totalCharge }} kwh</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalConsume" label="总耗电量(kwh)" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.totalConsume }} kwh</span>
          </template>
        </el-table-column>
        <el-table-column prop="avgConsumption" label="平均电耗(kwh/km)" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.avgConsumption }} kwh/km</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalMileage" label="总里程(km)" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.totalMileage }} km</span>
          </template>
        </el-table-column>
        <el-table-column prop="speed" label="行驶速度(km/h)" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.speed }} km/h</span>
          </template>
        </el-table-column>
        <el-table-column prop="positiveInsulationResistance" label="正极绝缘电阻阻值(Ω)" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.positiveInsulationResistance }} Ω</span>
          </template>
        </el-table-column>
        <el-table-column prop="faultComponentCode" label="故障部件代号" min-width="140"></el-table-column>
        <el-table-column prop="dcdcStatus" label="DCDC状态" min-width="100">
          <template slot-scope="scope">
            <span>{{ formatDcdcStatus(scope.row.dcdcStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dcTemperature" label="DC温度(℃)" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.dcTemperature }}℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="batteryInletTemp" label="锂电池进水温度(℃)" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryInletTemp }}℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="batteryOutletTemp" label="锂电池出水温度(℃)" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.batteryOutletTemp }}℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="tmsStatus" label="TMS工作状态" min-width="130">
          <template slot-scope="scope">
            <span>{{ formatTmsStatus(scope.row.tmsStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="highVoltageEmergencyStop" label="高压急停开关状态" min-width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.highVoltageEmergencyStop ? 'danger' : 'success'">
              {{ scope.row.highVoltageEmergencyStop ? '触发' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="chargingLineConnected" label="充电线连接状态" min-width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.chargingLineConnected ? 'success' : 'info'">
              {{ scope.row.chargingLineConnected ? '已连接' : '未连接' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="dataTime" label="数据时间" min-width="180"></el-table-column>
      </el-table>
      
      <!-- 分页控件 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 导出对话框 -->
    <el-dialog
      title="导出数据"
      :visible.sync="exportDialogVisible"
      width="400px"
    >
      <el-form :model="exportForm" label-width="80px">
        <el-form-item label="导出字段">
          <el-checkbox-group v-model="exportForm.fields">
            <el-checkbox v-for="field in exportableFields" :key="field.value" :label="field.value">{{ field.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="导出格式">
          <el-radio-group v-model="exportForm.format">
            <el-radio label="excel">Excel</el-radio>
            <el-radio label="csv">CSV</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleExport">确定导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 假设项目中有这些API，如果没有请根据实际情况修改
// import { getVehicleDataList, exportVehicleData } from '@/http/vehicle'
// 导入导出工具
// import { export_json_to_excel } from '@/utils/Export2Excel'

export default {
  name: 'WholeStatistics',
  data() {
    return {
      loading: false,
      // 搜索表单
      searchForm: {
        vehiclePlate: '',
        vehicleStatus: '',
        accStatus: '',
        dataTimeRange: ''
      },
      // 表格数据
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      // 导出相关
      exportDialogVisible: false,
      exportForm: {
        fields: [],
        format: 'excel'
      },
      exportableFields: []
    }
  },
  mounted() {
    this.initExportableFields()
    this.loadData()
  },
  methods: {
    // 初始化可导出字段
    initExportableFields() {
      this.exportableFields = [
        { label: '车牌号', value: 'vehiclePlate' },
        { label: '车辆状态', value: 'vehicleStatus' },
        { label: 'ACC', value: 'accStatus' },
        { label: '档位', value: 'gear' },
        { label: '充电状态', value: 'chargingStatus' },
        { label: '充电模式', value: 'chargingMode' },
        { label: '系统故障等级', value: 'faultLevel' },
        { label: 'SOC(%)', value: 'soc' },
        { label: '车内温度', value: 'insideTemp' },
        { label: '车外温度', value: 'outsideTemp' },
        { label: '刹车行程值', value: 'brakeTravel' },
        { label: '加速踏板行程值', value: 'acceleratorTravel' },
        { label: '总充电量(kwh)', value: 'totalCharge' },
        { label: '总耗电量(kwh)', value: 'totalConsume' },
        { label: '平均电耗(kwh/km)', value: 'avgConsumption' },
        { label: '总里程(km)', value: 'totalMileage' },
        { label: '行驶速度(km/h)', value: 'speed' },
        { label: '正极绝缘电阻阻值(Ω)', value: 'positiveInsulationResistance' },
        { label: '故障部件代号', value: 'faultComponentCode' },
        { label: 'DCDC状态', value: 'dcdcStatus' },
        { label: 'DC温度(℃)', value: 'dcTemperature' },
        { label: '锂电池进水温度(℃)', value: 'batteryInletTemp' },
        { label: '锂电池出水温度(℃)', value: 'batteryOutletTemp' },
        { label: 'TMS工作状态', value: 'tmsStatus' },
        { label: '高压急停开关状态', value: 'highVoltageEmergencyStop' },
        { label: '充电线连接状态', value: 'chargingLineConnected' },
        { label: '数据时间', value: 'dataTime' }
      ]
      // 默认选择所有字段
      this.exportForm.fields = this.exportableFields.map(field => field.value)
    },
    
    // 加载数据
    async loadData() {
      this.loading = true
      try {
        // 实际项目中取消注释以下代码
        /*
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          vehiclePlate: this.searchForm.vehiclePlate,
          vehicleStatus: this.searchForm.vehicleStatus,
          accStatus: this.searchForm.accStatus,
          dataTime: this.searchForm.dataTimeRange
        }
        const res = await getVehicleDataList(params)
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
        */
        
        // 使用模拟数据
        this.generateMockData()
      } catch (error) {
        this.$message && this.$message.error('获取数据失败')
        this.generateMockData()
      } finally {
        this.loading = false
      }
    },
    
    // 生成模拟数据
    generateMockData() {
      const vehiclePlates = ['京A12345', '沪B23456', '粤C34567', '苏D45678', '浙E56789', '川F67890', '鲁G78901', '鄂H89012']
      const vehicleStatuses = ['running', 'stopped', 'charging', 'fault']
      const gears = ['P', 'N', 'D', 'R']
      const chargingModes = ['慢充', '快充', '无']
      const faultLevels = ['无故障', '轻微故障', '中度故障', '严重故障', '致命故障']
      const dcdcStatuses = ['工作中', '待机', '故障', '未启动']
      const tmsStatuses = ['制冷', '加热', '待机', '故障']
      
      const mockData = []
      const now = new Date()
      
      // 生成模拟数据
      for (let i = 0; i < 100; i++) {
        const vehicleStatus = vehicleStatuses[Math.floor(Math.random() * vehicleStatuses.length)]
        const isCharging = vehicleStatus === 'charging'
        const isFault = vehicleStatus === 'fault'
        const faultLevel = isFault ? faultLevels[Math.floor(Math.random() * 3) + 1] : '无故障'
        
        mockData.push({
          id: `vehicle_${i + 1}`,
          vehiclePlate: vehiclePlates[Math.floor(Math.random() * vehiclePlates.length)],
          vehicleStatus: vehicleStatus,
          accStatus: Math.random() > 0.3 ? 'on' : 'off',
          gear: gears[Math.floor(Math.random() * gears.length)],
          chargingStatus: isCharging ? '充电中' : (Math.random() > 0.8 ? '充满' : '未充电'),
          chargingMode: isCharging ? chargingModes[Math.floor(Math.random() * 2)] : '无',
          faultLevel: faultLevel,
          soc: Math.floor(Math.random() * 100),
          insideTemp: parseFloat((15 + Math.random() * 20).toFixed(1)),
          outsideTemp: parseFloat((10 + Math.random() * 25).toFixed(1)),
          brakeTravel: parseFloat((Math.random() * 100).toFixed(2)),
          acceleratorTravel: parseFloat((Math.random() * 100).toFixed(2)),
          totalCharge: parseFloat((Math.random() * 10000 + 5000).toFixed(2)),
          totalConsume: parseFloat((Math.random() * 8000 + 3000).toFixed(2)),
          avgConsumption: parseFloat((Math.random() * 2 + 0.5).toFixed(3)),
          totalMileage: parseFloat((Math.random() * 100000 + 10000).toFixed(2)),
          speed: vehicleStatus === 'running' ? Math.floor(Math.random() * 120) : 0,
          positiveInsulationResistance: parseFloat((Math.random() * 1000000 + 500000).toFixed(0)),
          faultComponentCode: isFault ? `FAULT_${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}` : '-',
          dcdcStatus: dcdcStatuses[Math.floor(Math.random() * dcdcStatuses.length)],
          dcTemperature: parseFloat((20 + Math.random() * 40).toFixed(1)),
          batteryInletTemp: parseFloat((15 + Math.random() * 30).toFixed(1)),
          batteryOutletTemp: parseFloat((15 + Math.random() * 30).toFixed(1)),
          tmsStatus: tmsStatuses[Math.floor(Math.random() * tmsStatuses.length)],
          highVoltageEmergencyStop: Math.random() > 0.95,
          chargingLineConnected: isCharging,
          dataTime: this.formatDateTime(new Date(now.getTime() - Math.random() * 86400000 * 30))
        })
      }
      
      // 分页处理
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.tableData = mockData.slice(start, end)
      this.total = mockData.length
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        vehiclePlate: '',
        vehicleStatus: '',
        accStatus: '',
        dataTimeRange: ''
      }
      this.currentPage = 1
      this.loadData()
    },
    
    // 刷新数据
    refreshData() {
      this.loadData()
    },
    
    // 分页变化
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    // 每页大小变化
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadData()
    },
    
    // 格式化车辆状态
    formatVehicleStatus(status) {
      const statusMap = {
        'running': '运行中',
        'stopped': '停止',
        'charging': '充电中',
        'fault': '故障'
      }
      return statusMap[status] || status
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        'running': 'success',
        'stopped': 'info',
        'charging': 'warning',
        'fault': 'danger'
      }
      return typeMap[status] || 'info'
    },
    
    // 格式化充电状态
    formatChargingStatus(status) {
      return status || '-'  
    },
    
    // 格式化故障等级
    formatFaultLevel(level) {
      return level || '-'  
    },
    
    // 获取故障等级标签类型
    getFaultLevelType(level) {
      const typeMap = {
        '无故障': 'success',
        '轻微故障': 'info',
        '中度故障': 'warning',
        '严重故障': 'danger',
        '致命故障': 'danger'
      }
      return typeMap[level] || 'info'
    },
    
    // 格式化DCDC状态
    formatDcdcStatus(status) {
      return status || '-'  
    },
    
    // 格式化TMS状态
    formatTmsStatus(status) {
      return status || '-'  
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    // 打开导出对话框
    openExportDialog() {
      this.exportDialogVisible = true
    },
    
    // 导出数据
    async handleExport() {
      try {
        // 实际项目中取消注释以下代码
        /*
        const params = {
          fields: this.exportForm.fields,
          format: this.exportForm.format,
          ...this.searchForm
        }
        await exportVehicleData(params)
        */
        
        // 前端模拟导出
        this.mockExport()
        this.$message && this.$message.success('导出成功')
        this.exportDialogVisible = false
      } catch (error) {
        this.$message && this.$message.error('导出失败')
      }
    },
    
    // 模拟导出
    mockExport() {
      console.log('导出数据:', {
        fields: this.exportForm.fields,
        format: this.exportForm.format
      })
      // 实际项目中可以使用导入的导出工具
      /*
      const exportData = this.tableData.map(row => {
        const exportRow = {}
        this.exportForm.fields.forEach(field => {
          // 处理需要格式化的字段
          if (field === 'vehicleStatus') {
            exportRow[field] = this.formatVehicleStatus(row[field])
          } else if (field === 'accStatus') {
            exportRow[field] = row[field] === 'on' ? '开' : '关'
          } else if (field === 'faultLevel') {
            exportRow[field] = this.formatFaultLevel(row[field])
          } else {
            exportRow[field] = row[field]
          }
        })
        return exportRow
      })
      
      const tHeader = this.exportForm.fields.map(field => {
        const found = this.exportableFields.find(f => f.value === field)
        return found ? found.label : field
      })
      const filterVal = this.exportForm.fields
      
      export_json_to_excel(tHeader, exportData, `整车数据_${this.formatDate(new Date())}`, filterVal)
      */
    },
    
    // 格式化日期（用于文件名）
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}${month}${day}${hours}${minutes}`
    }
  }
}
</script>

<style scoped>
.whole-statistics-container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-header h2 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-container {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.search-form .el-form-item {
  margin-right: 15px;
  margin-bottom: 10px;
}

.table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container .el-table {
  flex: 1;
  overflow: auto;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

/* 自定义表格样式 */
.el-table__header-wrapper,
.el-table__body-wrapper {
  overflow-x: auto;
}

.el-table th {
  white-space: nowrap;
  background-color: #f5f7fa;
  font-weight: 500;
}

.el-table td {
  white-space: nowrap;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .search-form .el-form-item {
    width: 100%;
    margin-right: 0;
  }
  
  .el-date-picker,
  .el-select,
  .el-input {
    width: 100% !important;
  }
}

/* 导出按钮 */
.export-btn {
  margin-left: 10px;
}
</style>